import React, {useContext, useState} from 'react';
import {Box, Button, Flex} from "@mantine/core";
import {ArrowNarrowLeft, Logout} from "tabler-icons-react";
import {setWorkflowStep} from "../../store/reducers/root";
import logOut from "../../utils/actions/logOut";
import {useDispatch, useSelector} from "react-redux";
import {ClientContext} from "../ClientProvider";

const Header = ({loading, setLoading}) => {
  const client = useContext(ClientContext);
  const dispatch = useDispatch();

  const [isHover, setIsHover] = useState(false);

  const user = useSelector((state) => state.user);
  const workflowStep = useSelector((state) => state.workflowStep);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const handleButtonGoBack = () => {
    dispatch(setWorkflowStep(0));
  };

  const handleLogOut = async () => {
    if (!user.logged) return;
    await logOut(client, dispatch, setLoading);
  };

  return (
    <Flex direction={"column"} align={"center"} mt={"32px"}>
      <Flex maw={"600px"} w={"100%"} justify={"space-between"}>
        {user.logged && (
          <>
            {workflowStep !== 0 ? (
              <Button
                mr={10}
                mb={10}
                radius={"xl"}
                w={"170px"}
                variant="subtle"
                color="gray"
                onClick={handleButtonGoBack}
                loading={loading}
                leftIcon={<ArrowNarrowLeft size={18} />}
              >
                Back To Folders
              </Button>
            ) : (
              <Box w={"150px"}></Box>
            )}

            <Button
              mr={10}
              mb={10}
              radius={"xl"}
              w={"120px"}
              onClick={handleLogOut}
              loading={loading}
              style={{
                border: isHover
                  ? "1px solid #545960"
                  : "1px solid #E7EBEF",
                backgroundColor: isHover ? "#545960" : "#F3F5F7",
                color: isHover ? "#E7EBEF" : "#545960",
              }}
              leftIcon={<Logout size={18} />}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              Log out
            </Button>
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default Header;
